import styled from '@emotion/styled';
import {
  spacer8,
  spacer24,
  spacer48,
  ButtonSecondary,
  screenSmMax,
  screenXsMax,
  cssColorValue,
  semanticColors,
} from '@spotify-internal/encore-web';

const DEFAULT_COVER_WIDTH = 264;

export const Container = styled.div`
  display: flex;
  gap: ${spacer48};
  align-items: center;
  padding: ${spacer24};
  border: 1px solid ${cssColorValue(semanticColors.decorativeSubdued)};
  border-radius: 8px;

  @media (max-width: ${screenXsMax}) {
    flex-direction: column;
    gap: ${spacer8};
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: ${DEFAULT_COVER_WIDTH}px;
  height: ${DEFAULT_COVER_WIDTH}px;
  border-radius: 6px;
  overflow: hidden;
  background: ${cssColorValue(semanticColors.decorativeSubdued)};

  @media (max-width: ${screenXsMax}) {
    width: 100%;
    max-width: ${DEFAULT_COVER_WIDTH}px;
    height: auto;
  }

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ImageUploadButtonContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${spacer24};
  align-items: center;
  text-align: center;

  @media (max-width: ${screenXsMax}) {
    gap: ${spacer8};
  }
`;

export const ImageUploadParagraph = styled.p`
  padding: ${spacer8};
  color: var(--text-base, #000000);
  font-size: 1rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${spacer8};

  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
  }
`;

// Overrides global Anchor styles
// TODO https://anchorfm.atlassian.net/browse/WHEEL-932: Remove global Anchor styles that compete with Encore
export const DownloadButton = styled(ButtonSecondary)`
  &:hover,
  &:focus,
  &:active,
  &:hover:active {
    color: inherit;
    text-decoration: none;
  }
`;
